import {action, computed, makeObservable, observable} from "mobx";

import type {ModalName, PopupParamsMap} from "../ui/screens/modals/modal-names";

export type ModalEntry = {
    [K in ModalName]: { name: K; params: PopupParamsMap[K] }
}[ModalName];

export class ModalController {
    modals: ModalEntry[] = [];

    constructor() {
        makeObservable(this, {
            modals: observable.shallow,
            open: action.bound,
            close: action.bound,
            top: computed,
        });
    }

    open(entry: ModalEntry) {
        const existing = this.modals.find(m => m.name === entry.name);
        if (existing) {
            existing.params = entry.params;
            this.modals = this.modals.filter(m => m !== existing);
            this.modals.push(existing);
        } else {
            this.modals.push(entry);
        }
    }

    close(name?: ModalName) {
        if (!name) {
            this.modals.pop();
        } else {
            this.modals = this.modals.filter(m => m.name !== name);
        }
    }

    isOpen(name: ModalName): boolean {
        return this.modals.some(m => m.name === name);
    }

    get top(): ModalEntry | null {
        return this.modals.length ? this.modals[this.modals.length - 1] : null;
    }
}
